<template>
  <div id="hcpRegister" class="content">
    <div id="hcpModal" v-if="!isFinished">
      <mu-stepper :activeStep="activeStep">
        <mu-step v-for="step, stepIndex in steps" :key="`step-${stepIndex}`">
          <mu-step-label>
            {{ step.label }}
          </mu-step-label>
        </mu-step>
      </mu-stepper>
      <mu-card v-for="step, stepIndex in steps" :key="`card-step-${stepIndex}`" v-show="stepIndex === activeStep">
        <mu-card-header>
          <div class="mu-card-title-container">
            <div class="mu-card-title">
              {{step.title}}
            </div>
            <div class="mu-card-sub-title" v-html="$sanitize(step.subTitle)"></div>
          </div>
        </mu-card-header>
        <mu-card-text>
          <div v-show="step.key === 'step1'">
            <mu-row>
              <mu-col width="100" tablet="50" desktop="50">
                <mu-text-field
                  hintText="example@nhs.net"
                  label="Your work email address"
                  type="email"
                  fullWidth
                  v-model="model.step1.work_email"
                />
                <mu-select-field
                  label="Your job title"
                  fullWidth
                  v-if="list.jobs.length"
                  v-model="model.step1.job_id">
                  <mu-menu-item
                    v-for="job, jobIndex in list.jobs"
                    :key="`job-${jobIndex}`"
                    :value="job.job_id"
                    :title="job.job_title"
                  />
                </mu-select-field>
                <mu-auto-complete
                  v-show="!listManualSurgery"
                  inputClass="surgerySearchTxt"
                  v-model="surgerySearchValue"
                  :maxHeight="250"
                  :scroller="scroller"
                  :openOnFocus="true"
                  label="Your surgery name"
                  fullWidth
                  hintText="Start typing to see results" filter="noFilter"
                  :dataSource="list.surgeries"
                  :dataSourceConfig="dataSourceConfig"
                  @change="handleSurgerySelected"
                ></mu-auto-complete>
                <mu-checkbox class="listManualSurgery" v-model="listManualSurgery" :label="'My surgery isn\'t listed'" @change="onListManualSurgery" />
                <mu-row v-if="listManualSurgery">
                  <mu-col desktop="100" tablet="100" width="100">
                    <h2>Manually enter surgery address</h2>
                  </mu-col>
                  <mu-col desktop="50" tablet="50" width="100">
                    <mu-text-field
                      v-validate
                      :data-vv-rules="'required'"
                      data-vv-name="surgery"
                      data-vv-value-path="inputValue"
                      data-vv-as="surgery"
                      :errorText="errors.first('surgery')"
                      hintText="Surgery name"
                      label="Surgery name"
                      v-model="model.step1.surgery.surgery_name"
                    />
                    <br/>
                    <mu-text-field
                      v-validate
                      :data-vv-rules="'required'"
                      data-vv-name="address_line_1"
                      data-vv-value-path="inputValue"
                      data-vv-as="Address line 1"
                      :errorText="errors.first('address_line_1')"
                      hintText="Address line 1"
                      label="Address line 1"
                      v-model="model.step1.surgery.address_line_1"
                    />
                    <br/>
                    <mu-text-field
                      hintText="Address line 2"
                      label="Address line 2"
                      v-model="model.step1.surgery.address_line_2"
                    />
                    <br/>
                  </mu-col>
                  <mu-col desktop="50" tablet="50" width="100">
                    <mu-text-field
                      v-validate
                      :data-vv-rules="'required'"
                      data-vv-name="surgery_postcode"
                      data-vv-value-path="inputValue"
                      data-vv-as="surgery postcode"
                      :errorText="errors.first('surgery_postcode')"
                      hintText="Postcode/Zip"
                      label="Postcode/Zip"
                      v-model="model.step1.surgery.postcode"
                    />
                    <mu-text-field
                      v-validate
                      :data-vv-rules="'required'"
                      data-vv-name="surgery_city"
                      data-vv-value-path="inputValue"
                      data-vv-as="surgery city"
                      :errorText="errors.first('surgery_city')"
                      hintText="City"
                      label="City"
                      v-model="model.step1.surgery.city"
                    />
                    <mu-text-field
                      hintText="County"
                      label="County"
                      v-model="model.step1.surgery.county"
                    />
                  </mu-col>
                </mu-row>
                <mu-col desktop="100" tablet="100" width="100">
                  <mu-select-field
                    v-if="list.state.countries"
                    :scroller="scroller"
                    v-validate
                    :data-vv-rules="'required'"
                    data-vv-name="country"
                    data-vv-value-path="inputValue"
                    data-vv-as="country"
                    :errorText="errors.first('relationship')"
                    :underlineShow="underlineShow"
                    fullWidth
                    v-model="model.step1.country_id"
                    :maxHeight="300"
                    hintText="Select country"
                    :label="'I live in'">
                    <mu-menu-item
                      v-for="item, index in list.state.countries"
                      :key="'country-'  + index"
                      :value="item.country_id"
                      :title="item.country_name"
                    >
                    </mu-menu-item>
                  </mu-select-field>
                </mu-col>
              </mu-col>
              <mu-col width="100" tablet="100" desktop="100">
                <div class="goals">
                  <h2>What goals are you hoping to achieve by joining the Low Carb Program?</h2>
                  <div class="goal" v-for="goal, goalIndex in list.goals" :key="`goal-${goalIndex}`">
                    <mu-checkbox
                      v-model="model.step1.goals"
                      name="goal"
                      :nativeValue="'' + goal.goal_id + ''"
                      :label="goal.goal"
                    />
                  </div>
                </div>
                <div class="agreement">
                  <p>By continuing, you agree to our <a :href="`${siteUrl}terms`">Terms & Conditions</a> and that you have read our <a :href="`${siteUrl}privacy`">Privacy Policy</a>, including our cookie policy</p>
                </div>
              </mu-col>
            </mu-row>
          </div>
          <div v-show="step.key === 'step2'">
            <p>We accept the following file types: PDF, GIF, JPG and PNG</p>
            <p>The following types of documentation are accepted:</p>
            <ul>
              <li>Passport</li>
              <li>Driving licence</li>
              <li>State-issued licence or ID card</li>
              <li>Medical ID</li>
              <li>Professional certification</li>
            </ul>
            <mu-flexbox id="dropzone" justify="space-between" align="center">
              <mu-flexbox-item class="area">
                <input type="file" id="myFile" multiple size="1" @change="onFileChange">
                <p v-if="!hasSelectedFiles">Drag and drop a file here <br> or click to browse</p>
                <mu-row v-if="hasSelectedFiles">
                  <mu-col v-for="f, fileIndex in model.step2.files" :key="`file-${fileIndex}`" width="100" tablet="100" desktop="100">
                    <mu-row class="file-row">
                      <mu-col width="33" tablet="33" desktop="33">
                        <span v-text="f.name"></span>
                      </mu-col>
                      <mu-col width="33" tablet="33" desktop="33">
                        <span v-text="convertSize(f.size)"></span>
                      </mu-col>
                      <mu-col width="33" tablet="33" desktop="33">
                        <mu-icon-button class="removeFile" @click="removeFile(f)" icon="close" />
                      </mu-col>
                    </mu-row>
                  </mu-col>
                </mu-row>
              </mu-flexbox-item>
            </mu-flexbox>
            <div class="agreement">
              <mu-checkbox v-model="model.step2.agree" label="I confirm that I am the person represented in the submitted documents" />
            </div>
          </div>
          <mu-raised-button class="button" fullWidth :label="isSaving ? 'Saving...' : 'Continue'" :disabled="isSaving" @click="nextStep" />
        </mu-card-text>
      </mu-card>
    </div>
    <div id="hcpFinished" v-if="isFinished">
      <mu-card>
        <mu-card-header>
          <mu-card-title title="Thank you for verifying" :subTitle="'Your ID documentation will be reviewed in the next 24 hours. You will recieve an email once your account is approved.'"></mu-card-title>
        </mu-card-header>
        <!--<mu-card-text>
          <mu-raised-button
            primary
            class="smoothBtn primary"
            label="Proceed to Dashboard"
            @click.native="goTo('Dashboard');"
          />
        </mu-card-text>-->
      </mu-card>
    </div>
  </div>
</template>
<script>
  import HcpApi from '../../../api/Hcp';
  import SurgeryApi from '../../../api/Surgery';
  
  
  import {Observable} from 'rxjs/Rx'
  import Config from '../../../config';

  let dataSourceConfig = {
    text: 'surgery_name',
    value: 'surgery_id'
  };

  let terms = '<a href="' + Config.siteUrl + 'terms">here</a>';

  export default {
    data() {
      return {
        siteUrl: Config.siteUrl,
        isFinished: false,
        status: {},
        isSaving: false,
        scroller: document.body,
        listManualSurgery: false,
        surgerySearchValue: '',
        dataSourceConfig: dataSourceConfig,
        activeStep: 0,
        steps: [
          {
            label: 'Surgery',
            title: 'Low Carb Program for Healthcare Professionals',
            subTitle: 'Please confirm your credentials to gain access to the Healthcare Professional Platform.',
            key: 'step1'
          },
          {
            label: 'Verify',
            title: 'Identity Verification',
            subTitle: 'Verification is how we ensure a safe and robust environment for healthcare professionals. Please upload up to two valid forms of documentation to confirm your identity and credentials.',
            key: 'step2'
          }
        ],
        list: {
          state: [],
          goals: [],
          jobs: [],
          surgeries: [],
        },
        model: {
          step1: {
            work_email: '',
            job_id: 1,
            goals: [],
            surgery: {
              surgery_name: '',
              address_line_1: '',
              address_line_2: '',
              postcode: '',
              city: '',
              county: ''
            },
            country_id: 235
          },
          step2: {
            files: [],
            agree: false,
          }
        },
      }
    },
    methods: {
      onFileChange(e) {
        let self = this;
        self.clearFiles();
        var files = e.target.files || e.dataTransfer.files;
        if(files.length > 3) {
          self.$toastr.error('Maximum 3 files allowed');
          self.clearFiles();
        } else {
          for (var i = files.length - 1; i >= 0; i--) {
            self.model.step2.files.push(files[i]);
          }
        }
      },
      removeFile(file) {
        let self = this;
        self.model.step2.files.splice(self.model.step2.files.indexOf(file), 1);
      },
      clearFiles() {
        let self = this;
        self.model.step2.files = [];
      },
      onListManualSurgery() {
        let self = this;
        self.model.step1.surgery = {};
        self.surgerySearchValue = "";
      },
      nextStep() {
        let self = this;
        self.saveStep();
      },
      saveStep() {
        let self = this,
            step = self.steps[self.activeStep],
            errorMessage = 'Sorry, you do not have access to the HCP';
        if ( step.key === 'step1' ) {
          self.isSaving = true;
          HcpApi.registerHcp('surgery', self.model.step1).then(response => {
            if(!response.data.error) {
              self.isSaving = false;
              self.$toastr.success(response.data.message);
              self.activeStep += 1;
            }
          }).catch(error => {
            if(error.response.data) {
              self.isSaving = false;
              if(Array.isArray(error.response.data.message)) {
                for (var i = 0; i < error.response.data.message.length; i++) {
                  self.$toastr.error(error.response.data.message[i]);
                }
              } else {
                self.$toastr.error(error.response.data.message || errorMessage);
              }
            }
          });
        }
        if ( step.key === 'step2' ) {
          if(self.model.step2.agree) {
            if(self.hasSelectedFiles) {
              self.isSaving = true;
              let fd = new FormData();
              let filesLength = self.model.step2.files.length;
              for (var i = 0; i < filesLength; i++) {
                let file = self.model.step2.files[i];
                fd.append("files[]", file);
              }
              if(filesLength < 2) {
                self.$toastr.error("Please upload at least two documents");
                self.isSaving = false;
              } else {
                HcpApi.uploadVerificationFiles(fd).then(response => {
                  self.isSaving = false;
                  $.each(response.data.message, function(i, value) {
                    if(value.error) {
                      self.$toastr.error(value.message);
                    } else {
                      self.$toastr.success(value.message);
                    }
                    self.fetchHcpStatus();
                  });
                })
              }
            } else {
              self.$toastr.error("Please upload verification files to proceed");
            }
          } else {
            self.$toastr.error("Please confirm you are the person represented in the submitted documents");
          }
        }
      },
      listHcpGoals() {
        let self = this;
        if(self.$store.state.hcp.goals.length > 0) {
          self.list.goals = self.$store.state.hcp.goals;
        } else {
          HcpApi.listHcp('goals').then(response => {
            self.list.goals = response.data;
            self.$store.commit('setHcpGoals', response.data);
          });
        }
      },
      listHcpJobs() {
        let self = this;
        if(self.$store.state.hcp.jobs.length > 0) {
          self.list.jobs = self.$store.state.hcp.jobs;
        } else {
          HcpApi.listHcp('jobs').then(response => {
            self.list.jobs = response.data;
            self.$store.commit('setHcpJobs', response.data);
          });
        }
      },
      handleSurgerySelected(value) {
        let self = this;
        let object = (
          self.list.surgeries.filter(function (surgery) {
            return surgery.surgery_name === value
          })
        )[0];
        self.model.step1.surgery = object;
      },
      handleSurgerySearch(filter) {
        let self = this;
        SurgeryApi.searchSurgeriesByQuery(filter).then(response => {
          var surgeryLength = response.data.surgeries.length
          for (var i = 0; i < surgeryLength; i++) {
            response.data.surgeries[i].surgery_name += ', ' + response.data.surgeries[i].address_line_2 + ', ' + response.data.surgeries[i].postcode
          }
          self.list.surgeries = response.data.surgeries
        })
      },
      convertSize(size) {
        let _size = size,
          fSExt = ['Bytes', 'KB', 'MB', 'GB'],
          i=0;while(_size>900){_size/=1024;i++;}
        return (Math.round(_size*100)/100)+' '+fSExt[i];
      },
      goTo(name) {
        let self = this;
        self.$router.push({
          name: name
        })
      },
      fetchHcpStatus() {
        let self = this;
        self.status = {};
        HcpApi.getHcpUser().then(response => {
          self.status = response.data.steps;
          if(response.data.scope.verified) {
            self.$router.push({
              name: 'Dashboard'
            })
          } else {
            if(self.status.complete) {
              self.isFinished = true;
            } else {
              if(self.status.surgery) {
                self.activeStep = 1;
              } else if (self.status.verify) {
                self.activeStep = 0;
              }
            }
          }
        }).catch(error => {
           if(error.response.data.status === 403) {
             self.$router.push({
               name: 'Dashboard'
             });
           }
        });
      },
      initMounted() {
        let self = this;
        Observable.fromEvent($('.surgerySearchTxt'), 'input').map(x => x.currentTarget.value)
        .debounceTime(100).distinctUntilChanged()
        .subscribe(function (eventText) {
          self.handleSurgerySearch(eventText)
        });
        self.list.state = self.$store.state.list;
        self.$nextTick(function() {
          if(self.$store.state.user.isHcp === false) {
            self.$router.push({
              name: 'Dashboard'
            });
          }
        }, 1000);
        self.fetchHcpStatus();
        self.listHcpGoals();
        self.listHcpJobs();
      }
    },
    computed: {
      hasSelectedFiles() {
        let self = this;
        return self.model.step2.files.length > 0;
      },
    },
    mounted() {
      let self = this;
      self.initMounted();
    }
  }
</script>
<style lang="less">
  @import "GettingStarted.less";
</style>



// WEBPACK FOOTER //
// GettingStarted.vue?263e96e0